var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8VendingMachine50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF1744",
    d: "M37.5,3H31v38v1h9V5.5C40,4.1,38.9,3,37.5,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5CAE9",
    d: "M10.5,3C9.1,3,8,4.1,8,5.5V42h23V3H10.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M26,38H13c-0.6,0-1-0.5-1-1v-4c0-0.5,0.4-1,1-1h13c0.5,0,1,0.5,1,1v4C27,37.5,26.5,38,26,38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M27,29H12V7h15V29z M27,35v-2c0-0.5-0.5-1-1-1H13c-0.5,0-1,0.5-1,1v2H27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M8 40L8 41 8 42 8 45 11 45 12 42 36 42 37 45 40 45 40 42 40 41 40 40zM37.2 23h-3.4c-.4 0-.8-.3-.8-.8v-9.4c0-.4.3-.8.8-.8h3.4c.4 0 .8.3.8.8v9.4C37.9 22.7 37.6 23 37.2 23zM38 25.6c0-.3-.3-.6-.6-.6h-3.8c-.3 0-.6.3-.6.6V29h5C38 29 38 25.6 38 25.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M38,25.6c0-0.3-0.3-0.6-0.6-0.6h-3.8c-0.3,0-0.6,0.3-0.6,0.6V27h5C38,27,38,25.6,38,25.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC400",
    d: "M17.2,38l-0.4-2l5-1l0.4,2L17.2,38z M16,9h-2v5h2V9z M16,23h-2v4h2V23z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF59D",
    d: "M25,21h-2v-5h2V21z M19,9h-2v5h2V9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDD835",
    d: "M22,14h-2V9h2V14z M25,9h-2v5h2V9z M19,16h-2v5h2V16z M22,23h-2v4h2V23z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF6C00",
    d: "M22,21h-2v-5h2V21z M16,16h-2v5h2V16z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M25,27h-2v-4h2V27z M19,23h-2v4h2V23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8VendingMachine50);
export default __webpack_public_path__ + "static/media/icons8-vending-machine-50.d2247b77f8045f536e9b0d561cd799dc.svg";
export { ForwardRef as ReactComponent };